import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  makeStyles
} from '@material-ui/core';
import { store } from 'src/_helpers';

const useStyles = makeStyles(() => ({
  root: {}
}));

const ProfileDetails = ({ className, ...rest }) => {
  const classes = useStyles();
  let { authentication } = store.getState();
  const [passwordValue, setPasswordValue] = useState('');
  const [errora, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [customers, setCustomer] = useState({
    fullname: '',
    email: '',
    phone: ''
  });
  useEffect(() => {
    // console.log('customers', customers, user);
    getdata();
  }, []);

  //   SubscriptionType: "nill"
  // apiKey: "9c46f173b9743ee98d3ff2a4445cf48b7def0108202ddb524edb95f24a1ad7ece9db5bb649761466d410716e88e72eb4c7b36215c4a9a68d971c7b2078acc47ab4996f8e601df76061dc7e40ea7d06c5"
  // createdAt: "Fri Jan 15 2021 15:39:16 GMT+0000 (Coordinated Universal Time)"
  // email: "anas.ahmed142@gmail.com"
  // fullname: "anas ahmed"
  // id: "6001b724e0a39e1f9b6500b9"
  // noOfRequestRemaining: 0
  // remainingSubscription: "No Plan"
  // token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMDFiNzI0ZTBhMzllMWY5YjY1MDBiOSIsImVtYWlsIjoiYW5hcy5haG1lZDE0MkBnbWFpbC5jb20iLCJmdWxsbmFtZSI6ImFuYXMgYWhtZWQiLCJkYXRlIjoiMjAyMS0wMS0xNVQxNTo0NTowMy43OTBaIiwiaWF0IjoxNjEwNzI1NTAzLCJleHAiOjE2MTA3MjkxMDN9.2Dtw3ZKqSimL2U95dMV16Ftwuo6Az-C5Jf3g8w_Fir0"
  // totalCall: 0
  // type: "admin"
  // updatedAt: "2021-01-15T15:39:16.000Z"
  // validityOfSubscription: "nill"

  const getdata = async () => {
    let { user } = store.getState().authentication;
    try {
      await fetch(
        process.env.REACT_APP_BASE_URL +
          `/v10/user/${user?.id}?token=${user?.token}`
      )
        .then(response => response.json())
        .then(data => {
          // setusera(data.results[0]);
          var u = data.results[0];
          console.log(u, 'user');
          setCustomer(u);
        });
    } catch (er) {
      console.log(er);
    }
  };

  const handleKeyUp = e => {
    var value = e.target.value;
    if (value !== passwordValue) {
      setErrorText('Password Dindt Match!');
      setError(true);
    } else {
      setErrorText('');
      setError(false);
    }
  };

  const handleChange = event => {
    setCustomer({
      ...customers,
      [event.target.name]: event.target.value
    });
  };

  const onSubmit = () => {
    console.log('e', customers);
    var email = customers.email;
    var fullname = customers.fullname;
    var password = customers.password;
    var password2 = customers.password2;
    var phone = customers.phone;
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: authentication.user.token,
        email: email,
        fullname: fullname,
        phone: phone
      })
    };
    fetch(process.env.REACT_APP_BASE_URL + `/v10/user/update`, requestOptions)
      .then(handleResponse)
      .then(user => {
        let { results } = user;
        console.log('dasda', results);
      })
      .catch(err => {
        console.log(err);
      });
  };

  function handleResponse(response) {
    return response.text().then(text => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
          // auto logout if 401 response returned from api
          // logout();
          // location.reload(true);
        }

        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      return data;
    });
  }

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card>
        <CardHeader subheader="The information can be edited" title="Profile" />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                helperText="Please specify the Full Name"
                label="Full Name"
                name="fullname"
                onChange={handleChange}
                required
                value={customers?.fullname}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                helperText="Cant Edit This"
                name="email"
                type="email"
                required
                contentEditable={false}
                value={customers?.email}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                helperText="Please specify Proper no"
                name="phone"
                onChange={handleChange}
                type="number"
                value={customers?.phone}
                variant="outlined"
              />
            </Grid>
            {/* <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="New Password"
                helperText="Edit Only to Change Password"
                name="password2"
                onChange={handleChange}
                onKeyUp={e => {
                  setPasswordValue(e.target.value);
                }}
                type="password"
                value={customers?.password2}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                contentEditable={false}
                error={errora}
                fullWidth
                helperText={errorText}
                helperText="Confirm Change Password"
                label="Confirm Password"
                name="password"
                onChange={handleChange}
                onKeyUp={handleKeyUp}
                type="password"
                value={customers?.password}
                variant="outlined"
              />
            </Grid> */}
          </Grid>
        </CardContent>
        <Divider />
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button color="primary" variant="contained" onClick={onSubmit}>
            Save details
          </Button>
        </Box>
      </Card>
    </form>
  );
};

ProfileDetails.propTypes = {
  className: PropTypes.string
};

export default ProfileDetails;
